import React, { useState, useEffect } from 'react'
import { Styled } from './StaticBanner.styled'

import BannerMobile from 'assets/images/productsporto/img/BannerMobile.jpg'
import BannerTablet from 'assets/images/productsporto/img/BannerTablet.jpg'
import BannerDesk from 'assets/images/productsporto/img/BannerDesk.jpg'

const StaticBanner = (props) => {
  const [currentImage, setCurrentImage] = useState('')

  useEffect(() => {
    updateBannerImage()
    
    const handleResize = () => {
      updateBannerImage()
    }
    
    window.addEventListener('resize', handleResize)
    
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const updateBannerImage = () => {
    const windowWidth = window.innerWidth
    let image = ''
    
    if (windowWidth > 1024) {
      image = BannerDesk
    } else if (windowWidth <= 1024 && windowWidth >= 768) {
      image = BannerTablet
    } else {
      image = BannerMobile
    }
    
    setCurrentImage(image)
  }

  return (
    <Styled.Wrap>
      <Styled.BannerContainer>
        <Styled.BannerImage 
          src={currentImage} 
          alt="Banner Porto Seguro"
        />
      </Styled.BannerContainer>
    </Styled.Wrap>
  )
}

export default StaticBanner
